import { useSyncExternalStore } from "react";

import {
  type ActiveExchange,
  getActiveExchange,
  subscribeActiveExchange,
} from "@/shared/lib/active-exchange";

let cache: ActiveExchange | null = null;
let cacheKey: string | null = null;

/**
 * useSyncExternalStore сравнивает снимки по ссылке, поэтому отдаём тот же
 * объект, пока строка в localStorage не поменялась.
 */
const getSnapshot = (): ActiveExchange | null => {
  const active = getActiveExchange();
  const key = active ? JSON.stringify(active) : null;

  if (key !== cacheKey) {
    cacheKey = key;
    cache = active;
  }

  return cache;
};

export const useActiveExchange = () =>
  useSyncExternalStore(subscribeActiveExchange, getSnapshot);
